import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-lucky-slider1",
    templateUrl: "./lucky-slider1.component.html",
    styleUrls: ["./lucky-slider1.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class LuckySlider1Component implements OnInit {
  title: string;
  languageCode: string = "en";
  description: string;
  constructor(private router: Router, private luckyNumberService: LuckyNumberService,
    private matDialog: MatDialog, private authService: AuthService,) {
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
    });
  }
  cancelSlider(event) {
    event.stopPropagation();
    this.router.navigateByUrl("mainTabs/tabs/syndicate");
  }

  nextSlider(event, nextSlider) {
    event.stopPropagation();
    this.router.navigateByUrl(`/syndicate/lucky-slider${nextSlider}`);
  }

  ngOnInit(): void {
    const isEmpty = (val: any) => val === null || !(Object.keys(val) || val).length;
    this.luckyNumberService.getOnboardData("lucky_number").subscribe((onBoardRef: Data) => {
      if (onBoardRef?.exists && !isEmpty(onBoardRef?.data())) {
        const pageOneData = onBoardRef?.data();
        const pageOneContent = pageOneData?.lucky_numbers?.page_1;
        this.description = pageOneContent?._description ? pageOneContent?._description?.[this.languageCode] : pageOneContent?.description;
        this.title = pageOneContent?._title ? pageOneContent?._title?.[this.languageCode] : pageOneContent?.title;
      }
    });
  }
  closePopup() {
    this.matDialog.closeAll();
  }
}
